import React from "react";
import { Link } from 'react-router-dom';
import Card from "react-bootstrap/Card"
import Up from "../../assets/images/up.svg";
import Tech from "../../assets/images/techno.svg";
import Tv from "../../assets/images/tv.svg";
import Internet from "../../assets/images/internet0.svg";
import Rural from "../../assets/images/rural.svg";
import Rede from "../../assets/images/rede.fw.png";
import Apps from "../../assets/images/apps.svg";
import Judge from "../../assets/images/Judge.svg"
import Telefone from "../../assets/images/telefone.svg";
import * as FaIcons from "react-icons/fa";
import * as FcIcons from "react-icons/fc";
import * as ImIcons from "react-icons/im";
import * as AiIcons from "react-icons/ai";


import "./styles.css";

const Home = () => {
  return (
    <>
      <Card>
        <Card.Header><div className="card-title"><FcIcons.FcGraduationCap />  GigaAcad</div> </Card.Header>
      </Card >
      <div className="container">
        <div className="row">
          <div className="content">
            <h1>Centro de aprendizagem da Gigabyte Telecom</h1>
          </div>
          <div className="col-sm-12 col-md-3">
            <img src={Up} alt="Foto" />
          </div>
          <div className="col-sm-12 col-md-9">
            <div className="content-text">
              <h4>Guia de Serviços Prestados pela Gigabyte Telecom</h4>
              <span>
                Bem-vindo ao Guia de Serviços da Gigabyte Telecom!
                Aqui você encontrará informações essenciais sobre nossos serviços de Internet,
                TV por assinatura, Telefonia Fixa e Internet Rural.<br />
                Estamos desenvolvendo este guia para ajudar nossos colaboradores a entender e utilizar com eficiência
                os serviços que oferecemos. Ele contém orientações claras e úteis para configurar dispositivos,
                solucionar problemas técnicos e garantir uma experiência satisfatória aos nossos clientes.<br />
                Caso você precise de assistência adicional, nossa equipe de atendimento está pronta para ajudar.
                Entre em contato com um de nossos supervisores.<br />

                Agradecemos por ser parte da Gigabyte Telecom e por contribuir para oferecer a melhor experiência de telecomunicações aos nossos clientes.
              </span>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div className="container">
        <div className="row">
          <h4>Instruções para alguns dos serviços prestados pela Gigabyte Telecom</h4>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><ImIcons.ImConnection /> Planos de Internet </h5></Card.Header>

                <Card.Body>
                  <Card.Title><h6>Planos diferentes para cada perfil</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Internet} alt="fone" />
                    </div>
                    <span>
                      Planos personalizados para atender diferentes perfis de clientes...
                    </span>
                  </Card.Text>
                  <Link to="/internet" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><ImIcons.ImDisplay /> Planos de TV</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Veja nosssos planos de TV</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Tv} alt="fone" />
                    </div>
                    <span>
                      App, Set-Top Box, como funciona a nossa TV por assinatura...
                    </span>
                  </Card.Text>
                  <Link to="/tvs" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><FaIcons.FaPhone /> Telefonia Fixa</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Praticidade e economia</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Telefone} alt="fone" />
                    </div>
                    <span>
                      A telefonia fixa via internet oferece praticidade e economia...
                    </span>
                  </Card.Text>
                  <Link to="/telefones" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><FaIcons.FaSignal /> Internet Rural</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>O cliente sempre conectado!</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Rural} alt="fone" />
                    </div>
                    <span>
                      Tenha internet em sua fazenda, chácara ou sítio...
                    </span>
                  </Card.Text>
                  <Link to="/internet" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <br />
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><AiIcons.AiOutlineApartment /> Nocões básicas sobre redes </h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Redes e Internet</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Rede} alt="fone" />
                    </div>
                    <span>
                      Guia para iniciantes adquirir noções básicas sobre Redes...
                    </span>
                  </Card.Text>
                  <Link to="/rede" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><FaIcons.FaAppStoreIos /> Aplicativos Gigabyte</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Informações sobre os Aplicativos</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Apps} alt="fone" />
                    </div>
                    <span>
                      Gigabyte Cliente, Gigabyte Play, TR-069, etc.
                    </span>
                  </Card.Text>
                  <Link to="/apps" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><FaIcons.FaMobile />Siglas e significados</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Fique por dentro da tecnologia</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Tech} alt="fone" />
                    </div>
                    <span>
                      Você sabe o que é OLT, ONU, ONT, STB etc...
                    </span>
                  </Card.Text>
                  <Link to="/siglas" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="col-sm-12 col-md-3">
            <div className="content-card">
              <Card>
                <Card.Header><h5><FaIcons.FaGavel />  Conformidade</h5></Card.Header>
                <Card.Body>
                  <Card.Title><h6>Obrigações legais</h6></Card.Title>
                  <hr />
                  <Card.Text>
                    <div className="img-icon">
                      <img src={Judge} alt="fone" />
                    </div>
                    <span>
                      Garantindo a Obrigatoriedade e Cumprimento das Leis.
                    </span>
                  </Card.Text>
                  <Link to="/normas" className="btn btn-primary">Saiba mais...</Link>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>

      <div className="end"></div>

    </>
  );
};

export default Home;
